<template>
  <div>
    <b-row
      class="justify-content-center"
      style="width: 100%; height: 100; overflow: hidden;"
    >
      <div class="col-md-12">
        <a href="/"
          ><img
            :src="logo"
            style="width: 135px; float: left; padding: 8px;"
          />
        </a>
      </div>
    </b-row>
    <div
      class="app flex-row align-items-center"
      v-bind:style="{ 'background-image': 'url(' + bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'}">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6" sm="8">
            <b-card no-body class="mx-4">
              <b-card-body class="p-4">
                <div class="row">
                  <div
                    :class="status_color"
                    role="alert"
                    v-if="hasErrors.message"
                    data-dismiss="alert"
                  >
                    <strong
                      ><small>{{ errorMessage.message }}</small></strong
                    >
                  </div>
                </div>
                <h1>Reset Password</h1>
                <p class="text-muted">Please check the email for OTP:</p>
                <small class="help-block" v-if="hasErrors.username"
                  ><strong style="color: red;">{{
                    errorMessage.username
                  }}</strong></small
                >

                <div class="row">
                  <b-col sm="12">
                    <b-form-group>
                      <label for="otp"> Token Id:</label>
                      <b-form-input
                        type="text"
                        v-model="resetotp"
                        :class="{ 'is-invalid': hasErrors.otp }"
                        placeholder="Otp"
                      ></b-form-input>
                      <small
                        class="form-text text-muted"
                        v-if="hasErrors.otp === true"
                        ><strong style="color: red;">{{
                          errorMessage.otp
                        }}</strong></small
                      >
                    </b-form-group>
                  </b-col>
                </div>

                <div class="row">
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name"> New Password :</label>
                      <b-form-input
                        type="password"
                        v-model="resetpassword"
                        :class="{ 'is-invalid': hasErrors.new }"
                        placeholder="New Password"
                      ></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.new"
                        ><strong style="color: red;">{{
                          errorMessage.new
                        }}</strong></small
                      >
                    </b-form-group>
                  </b-col>
                </div>

                <div class="row">
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name"> Confirm Password :</label>
                      <b-form-input
                        type="password"
                        v-model="resetpasswordconf"
                        :class="{ 'is-invalid': hasErrors.confirm }"
                        placeholder="Confirm Password"
                      ></b-form-input>
                      <small
                        class="form-text text-muted"
                        v-if="hasErrors.confirm"
                        ><strong style="color: red;">{{
                          errorMessage.confirm
                        }}</strong></small
                      >
                    </b-form-group>
                  </b-col>
                </div>

                <b-row>
                  <b-col sm="4">
                    <b-button @click.prevent="Submit()" variant="primary" block
                      >Verify</b-button
                    >
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="12">
                    <label style="font-size: 15px;" class="form-text text-muted"
                      >Click
                      <a
                        @click.prevent="Login()"
                        style="
                          color: #63c2de;
                          font-size: 15px;
                          cursor: pointer;
                        "
                        >here</a
                      >
                      to Login</label
                    >
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <Spinner v-if="loading"></Spinner>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "../../spinner.vue";

export default {
  name: "ResetPassword",
  components: {
    Spinner,
  },

  data() {
    return {
      logo:null,
      bg_img:null,
      loading: false,
      resetotp: "",
      resetpassword: "",
      resettoken: "",
      resetpasswordconf: "",
      email: "",
      status_color: null,
      hasErrors: {
        new: false,
        confirm: false,
        otp: false,
        message: false,
      },
      errorMessage: {
        new: "",
        confirm: "",
        message: "",
        otp: "",
      },
    };
  },
  created() {
    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    this.test();
  },

  methods: {
    test() {
      // console.log(this.$route.query)
      if (this.$route.query.access_token == undefined) {
        this.$router.push("/");
      } else {
        this.resettoken = this.$route.query.access_token;
        this.email = this.$route.query.email;
      }
    },

    reset_all() {
      this.hasErrors.new = false;
      this.hasErrors.confirm = false;
      this.hasErrors.otp = false;
      this.errorMessage.new = "";
      this.errorMessage.confirm = "";
      this.errorMessage.otp = "";
      this.status_color = null;
    },

    Submit() {
      this.errorMessage.message = "";
      this.reset_all();
      var submit = 0;
      var pass = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;
      if (this.resetpassword.length == 0) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new = "Password Required";
      } else if (pass.test(this.resetpassword) == false) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new =
          "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
      }
      if (this.resetpasswordconf.length == 0) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm = "Confirm Password Required";
      } else if (this.resetpassword != this.resetpasswordconf) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm =
          "Password and Confirm Password does not match";
      }
      if (this.resetotp == "") {
        submit = 1;
        this.hasErrors.otp = true;
        this.errorMessage.otp = "Token Id Required";
      }
      if (submit == 0) {
        this.handleSubmit();
      }
    },

    handleSubmit() {
      var _this = this;
      this.loading = true;
      var data = { newPassword: this.resetpassword };
      this.$http
        .post("/api/users/reset-password?access_token=" + this.resettoken, data)
        .then(function (response) {
          _this.loading = false;
          _this.errorMessage.message = "Password Reset Successfully";
          _this.status_color = "col-md-12 alert alert-success";
          _this.hasErrors.message = true;
        })
        .catch(function (error) {
          _this.loading = false;
          _this.errorMessage.message = "Something Went Wrong :(";
          _this.status_color = "col-md-12 alert alert-danger";
          _this.hasErrors.message = true;
        });
    },

    Login() {
      this.$router.push("/");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/ResetPassword.vue